import { metricCompatibleFontFaceCss } from '@/templates/domain/constants/metricCompatibleFonts';

const FONT_FACE_CSS = metricCompatibleFontFaceCss();

/** Declares the open stand-ins for the proprietary faces a quote may name (see `metricCompatibleFonts`). */
export function MetricCompatibleFontFaces() {
  if (!FONT_FACE_CSS) return null;
  return <style>{FONT_FACE_CSS}</style>;
}
